import { useEffect, useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import useHttp from '../../../../../../../hooks/use-http';

const ChatPreview = ({ oznaka, idMasine, datum }) => {
  const [messages, setMessages] = useState([]);
  const myUserId = +localStorage.getItem('idKorisnika');
  const { getData } = useHttp('');

  useEffect(() => {
    const fetchChat = async () => {
      try {
        let config;
        if (idMasine != null && datum) {
          config = {
            url: 'DnevnaEvidencija/vracanje_konverzacije_za_oznaku_testiranje',
            method: 'POST',
            data: { idMasine, datum },
          };
        } else if (oznaka) {
          config = {
            url: 'Masine/vracanje_konverzacije_za_oznaku',
            method: 'POST',
            data: { oznaka },
          };
        } else {
          setMessages([]);
          return;
        }
        const response = await getData(config);
        setMessages(Array.isArray(response) ? response : []);
      } catch (err) {
        console.error('Greška pri učitavanju poruka:', err);
        setMessages([]);
      }
    };

    fetchChat();
  }, [oznaka, idMasine, datum]);

  return (
    <Box sx={{ p: 2, height: '100%', overflowY: 'auto' }}>
      {messages.map((msg) => {
        const isMine = String(msg.senderId) === String(myUserId);
        const senderName = isMine ? '' : msg.name || 'Nepoznat';
        const timeStr = new Date(msg.createdAt).toLocaleTimeString('sr-RS', {
          hour: '2-digit',
          minute: '2-digit',
        });

        return (
          <Box
            key={msg.id}
            sx={{
              display: 'flex',
              justifyContent: isMine ? 'flex-end' : 'flex-start',
              mb: 1,
            }}
          >
            <Paper
              sx={{
                p: 1,
                bgcolor: isMine ? '#DCF8C6' : '#FFF',
                maxWidth: '70%',
                borderRadius: 2,
              }}
            >
              {/* ime iznad poruke */}
              {!isMine && (
                <Typography
                  variant="caption"
                  sx={{ fontSize: '0.72rem', color: '#667781' }}
                >
                  {senderName}
                </Typography>
              )}

              {/* telo poruke */}
              {msg.body && (
                <Typography
                  variant="body2"
                  sx={{ whiteSpace: 'pre-line', wordWrap: 'break-word' }}
                >
                  {msg.body}
                </Typography>
              )}

              {/* slika ako postoji */}
              {msg.image && (
                <Box
                  sx={{
                    mt: msg.body ? 1 : 0,
                    display: 'flex',
                    justifyContent: isMine ? 'flex-end' : 'flex-start',
                  }}
                >
                  <img
                    src={msg.image}
                    alt="slika"
                    style={{
                      maxWidth: '100%',
                      borderRadius: '10px',
                      objectFit: 'cover',
                      cursor: 'pointer',
                    }}
                    onClick={() => window.open(msg.image, '_blank')}
                  />
                </Box>
              )}

              {/* vreme ispod poruke */}
              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  textAlign: 'right',
                  fontSize: '0.7rem',
                  color: '#666',
                  mt: 0.5,
                }}
              >
                {timeStr}
              </Typography>
            </Paper>
          </Box>
        );
      })}
    </Box>
  );
};

export default ChatPreview;
